import classNames from 'classnames';

import { getGoalTriggerDisplayModel } from '/src/features/goals/triggerMetadata';

const buildTextSummaryFromTrigger = (trigger) => {
  const { summarySegments: segments } = getGoalTriggerDisplayModel(trigger);
  if (!segments.length) return '';

  return segments.join(' ').trim();
};

export function GoalTriggerSummary({ goal, showMaxTriggers = 2, showIntroText = true, className }) {
  const triggerList = Array.isArray(goal?.triggers) ? goal.triggers : [];
  const hasTriggers = triggerList.length > 0;

  if (!hasTriggers) {
    return null;
  }

  const textTriggers = triggerList
    .filter((trigger) => !trigger.deletedAt)
    .map((trigger, triggerIndex) => ({
      key: trigger?.id ?? triggerIndex,
      message: buildTextSummaryFromTrigger(trigger),
    }))
    .filter((trigger) => trigger.message);

  if (!textTriggers.length) {
    return null;
  }

  const truncatedTriggers = textTriggers.slice(0, showMaxTriggers ?? undefined);
  const leftOverTriggers = showMaxTriggers ? textTriggers.slice(showMaxTriggers) : [];

  return (
    <div className={classNames('text-caption flex flex-col', className)}>
      {showIntroText ? <span className="block">Conversion triggered when someone:</span> : null}

      <ul className="inline-block max-w-full list-outside list-disc pl-5 text-left ">
        {truncatedTriggers.map((trigger, index) => (
          <li key={`Goal-${goal?.id ?? 'goal'}_trigger_${trigger.key}`}>
            <div className="flex items-center space-x-1 overflow-hidden">
              <span className="leading-tight truncate">{trigger.message}</span>
              {truncatedTriggers.length > index + 1 ? <span className="!ml-0 shrink-0">, or</span> : null}
            </div>
          </li>
        ))}
      </ul>

      {leftOverTriggers.length > 0 ? (
        <div className={classNames('font-semibold', { 'ml-5': truncatedTriggers.length > 1 })}>
          +{leftOverTriggers.length} more triggers
        </div>
      ) : null}
    </div>
  );
}
